export const set_jwt = (json_data) => ({
  type: 'set_jwt',
  payload: json_data,
});
export const remove_jwt = () => ({
  type: 'remove_jwt',
});
